// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"461":"skills","554":"examples"}[chunkId] + "." + {"461":"3ab01847","554":"97b55aae"}[chunkId] + ".css";
};